import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * 保留 locationId（snowflake ID）精度。
 */
function parseTravelJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const text = raw.replace(
    /("locationId"\s*:\s*)(\d{15,})/g,
    '$1"$2"',
  );
  return JSON.parse(text);
}

const snowflakeJson = { transformResponse: [parseTravelJson] };

/**
 * External location resolve API（MAP-GOOGLE-E1）。
 * FE 只應使用回傳的 locationId 寫入 Activity，不可存入 providerPlaceId。
 */
export const externalLocationApi = {
  /**
   * 解析外部 provider 地點至內部 geo location。
   * @param {{ provider: string, providerPlaceId: string }} params
   */
  resolve: ({ provider, providerPlaceId }) =>
    travelClient.post(
      travelEndpoints.resolveExternalLocation,
      { provider, providerPlaceId },
      snowflakeJson,
    ),
};
